var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}; // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore


import FileSaver from 'file-saver';
import Config from '../config/config';
import request from './request';
import { getToken } from './token';

function makeRequest(endpoint, method, body) {
  if (method === void 0) {
    method = 'GET';
  }

  return __awaiter(this, void 0, void 0, function () {
    var headers, credentials, requestParams;
    return __generator(this, function (_a) {
      headers = new Headers({
        Authorization: "Bearer " + getToken()
      });

      if (method !== 'GET') {
        headers.append('Content-Type', 'application/json');
      }

      credentials = 'same-origin';
      requestParams = {
        method: method,
        body: body,
        headers: headers,
        credentials: credentials
      };
      return [2
      /*return*/
      , fetch(endpoint, requestParams).then(function (res) {
        if (res.status !== 200) {
          throw new Error('Error occurred');
        }

        return {
          status: 200
        };
      })];
    });
  });
}

export var customBulkExport = function customBulkExport(sku, possibleValues, preferredCombinationsId) {
  var body = {
    sku: sku,
    possibleValues: possibleValues,
    preferredCombinationsId: preferredCombinationsId || null
  };
  return makeRequest(Config.urls.CUSTOM_BULK_EXPORT, 'POST', JSON.stringify(body));
};
export var getBulkDownloadJobs = function getBulkDownloadJobs() {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , request(Config.urls.BULK_DOWNLOAD_JOBS)];
    });
  });
};
export var deleteBulkDownloadJob = function deleteBulkDownloadJob(jobId) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , makeRequest(Config.urls.DELETE_BULK_DOWNLOAD_JOB + "/" + jobId, 'DELETE', null)];
    });
  });
};
export var downloadSampleCSV = function downloadSampleCSV(sku) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , request(Config.urls.DOWNLOAD_SAMPLE_FILE + "/" + sku, 'GET', null, true, 'excel').then(function (data) {
        if (!data.errorResponse) {
          FileSaver.saveAs(data, sku + "-Template");
          return {
            status: 200
          };
        }

        return data;
      })];
    });
  });
};
export var calculateCombinationsSize = function calculateCombinationsSize(possibilitiesSet, checked) {
  var numberOfCombinations = 1;

  if (possibilitiesSet) {
    Object.keys(possibilitiesSet).forEach(function (attribute) {
      var attributeValuesSize = possibilitiesSet[attribute].possibleValues.length;
      var selectedAttributeValues = checked[attribute];

      if (selectedAttributeValues && selectedAttributeValues.length > 0) {
        numberOfCombinations *= selectedAttributeValues.length;
      } else {
        numberOfCombinations *= attributeValuesSize > 0 ? attributeValuesSize : 1;
      }
    });
  }

  return numberOfCombinations;
};